<div class="container-fluid footer">
  <div>
    <div class="row">
      <div class="col-md-12 copyright">{{'COPYRIGHT' | translate}}</div>
    </div>
  </div>
</div>
